import { type KeyboardEvent, useEffect } from "react";
import { nextMenuIndex, NO_MOVE } from "./menuNavigation";

const ENABLED_ITEM = ".nb-menu-item:not(:disabled)";
/** The first enabled item of the open menu (portaled, so looked up from the document). */
const FIRST_ENABLED_ITEM = `.nb-popover[role='menu'] ${ENABLED_ITEM}`;

/**
 * Roving focus for an open menu: the first enabled item gets the focus on opening; the arrows
 * (wrapping), Home and End move it; Tab closes the menu. Returns the menu panel's keydown handler.
 */
export function useMenuRovingFocus(open: boolean, close: () => void): (e: KeyboardEvent<HTMLDivElement>) => void {
  useEffect(() => {
    if (!open) return;
    const frame = requestAnimationFrame(() => document.querySelector<HTMLButtonElement>(FIRST_ENABLED_ITEM)?.focus());
    return () => cancelAnimationFrame(frame);
  }, [open]);

  return function onKeyDown(e: KeyboardEvent<HTMLDivElement>): void {
    const items = Array.from(e.currentTarget.querySelectorAll<HTMLButtonElement>(ENABLED_ITEM));
    const current = items.indexOf(document.activeElement as HTMLButtonElement);
    if (e.key === "Tab") close();
    const next = nextMenuIndex(e.key, current, items.length);
    if (next === NO_MOVE) return;
    e.preventDefault();
    items[next]?.focus();
  };
}
